import { ApolloLink, Observable } from "@apollo/client";
import { GraphQLError } from "graphql";
import { getAccessToken, isTokenValid } from "@/lib/tokenManager";

/**
 * Link that prevents GraphQL requests from being sent without a valid bearer token.
 * This ensures we never make unauthenticated requests to the gateway.
 */
export const requireAuthLink = new ApolloLink((operation, forward) => {
  if (typeof window === "undefined") {
    return forward(operation);
  }

  const token = getAccessToken();

  if (!token || !isTokenValid(token)) {
    return new Observable((observer) => {
      observer.error(
        new GraphQLError("No valid access token available", {
          extensions: {
            code: "UNAUTHENTICATED",
          },
        })
      );
    });
  }

  return forward(operation);
});
